import _ from 'lodash';

let initEnrolments = {
	expires: 0,
	submitting: false,
	from: null,
	to: null,
	fetching_from: null,
	fetching_to: null,
	data: {
		enrolled: {},
		subscriptions: {},
		waitlisted: {},
		special_interests: {},
	},
}

const enrolments = (state = initEnrolments, action) => {
	switch (action.type) {
		case 'USER_FAILURE':
		case 'MEMBER_FAILURE':
		case 'LOGOUT_SUCCESS':
		case 'LOGIN_SUCCESS':
			return initEnrolments;
		case 'ENROLMENTS_REQUEST':
			return {...state, submitting: true, fetching_from: action.extra.from, fetching_to: action.extra.to}
		case 'ENROLMENTS_SUCCESS':
			const expires = Math.floor(Date.now() / 1000) + 3600; // current time + 1 hr
			const f = (state.from === null || action.extra.from < state.from) ? action.extra.from : state.from;
			const t = (state.to === null || action.extra.to > state.to) ? action.extra.to : state.to;
			
			const de = _.merge({...state.data.enrolled}, _.keyBy(action.response.enrolled, 'course_code'));
			const ds = _.merge({...state.data.subscriptions}, _.keyBy(action.response.subscriptions, 'course_code'));
			const dw = _.merge({...state.data.waitlisted}, _.keyBy(action.response.waitlisted, 'course_code'));
			const dsi = _.merge({...state.data.special_interests}, _.keyBy(action.response.special_interests, 'interest_code'));
			
			return {...state, expires: expires, data: {
				enrolled: de,
				subscriptions: ds,
				waitlisted: dw,
				special_interests: dsi
			}, submitting: false, from: f, to: t, fetching_from: null, fetching_to: null  }
			
		case 'ENROLMENTS_FAILURE':
			return {...state, submitting: false, fetching_from: null, fetching_to: null}
			
		case 'COURSE_WITHDRAWAL_SUCCESS':
		case 'UNDO_WITHDRAWAL_SUCCESS':
			let e = _.cloneDeep(state.data);
			if(action.response.status === 'Waitlist'){
				e.waitlisted[action.response.course_code] = action.response;
			} else {
				e.enrolled[action.response.course_code] = action.response;
			}
			return {...state, data: e}
		default:
			return state;
	}
}

export default enrolments